module.exports = __webpack_public_path__ + "static/img/not_found.9a268d12.png";